import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import EmptyCard from "components/Cards/EmptyCard";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";

export default function NotFound({ title }) {
  return (
    <>
      <WorkspaceHeader title={title} />
      <EmptyCard
        text="404 Not found"
        secondaryText="Please select a correct menu or try again."
        icon={<SentimentDissatisfiedOutlinedIcon color="error" fontSize="large" />}
      />
    </>
  );
}
